
export class Color {
  hex: string;
  nombre: string;
  constructor() {

  }

}